import { render } from "./CommentsFormSkeleton.vue?vue&type=template&id=21786ec8"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__